module.exports = __webpack_public_path__ + "step1_M2F_kanai_bridal.02802398.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step1_M2F_kanai_bridal.jpg
// module id = KPK4
// module chunks = 0